import React, { HTMLAttributes } from 'react';
import cx from 'classnames';

const BriefHeader: React.FC<HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return <span className={cx('brief__title', className)} {...props} />;
};

export default BriefHeader;
